import React from 'react';
import { Paper, Typography, Box } from '@mui/material';
import { getStatusColor } from './familyDashboard';

// Color scheme for each family member's tile
const USER_COLORS = {
    ryan: '#3182ce',      // Blue
    leah: '#805ad5',      // Purple
    samantha: '#d53f8c',  // Pink
    connor: '#38a169',    // Green
    marie: '#319795'      // Teal
};

// Darker hover colors
const USER_HOVER_COLORS = {
    ryan: '#2c5aa0',
    leah: '#6b46c1',
    samantha: '#b83280',
    connor: '#2f855a',
    marie: '#2c7a7b'
};

const ChoreTile = ({ user, onClick }) => {
    return (
        <Paper 
            elevation={6}
            sx={{ 
                p: 3,
                cursor: 'pointer',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                borderRadius: 4,
                bgcolor: USER_COLORS[user.id] || '#3182ce',
                height: '100%',
                minHeight: { xs: 180, md: 220 },
                position: 'relative',
                boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
                '&:hover': { 
                    transform: 'scale(1.03) translateY(-8px)',
                    boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
                    bgcolor: USER_HOVER_COLORS[user.id] || '#2c5aa0'
                },
                '&:active': {
                    transform: 'scale(0.98)'
                }
            }}
            onClick={() => onClick(user.id)}
        >
            {/* Status Indicator - Bottom Right Corner */}
            <Box 
                sx={{ 
                    position: 'absolute',
                    bottom: 12,
                    right: 12,
                    width: { xs: 24, md: 28 },
                    height: { xs: 24, md: 28 },
                    borderRadius: '50%',
                    bgcolor: getStatusColor(user.qualified),
                    border: '4px solid white',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.3)'
                }} 
            />
            
            {/* Avatar */}
            <Box 
                sx={{ 
                    width: { xs: 70, md: 90 },
                    height: { xs: 70, md: 90 },
                    borderRadius: '50%',
                    overflow: 'hidden',
                    border: '4px solid white',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                    mb: 2
                }}
            >
                <Box 
                    component="img" 
                    src={`${user.avatar}`} 
                    sx={{ 
                        width: '100%', 
                        height: '100%',
                        objectFit: 'cover' 
                    }}
                    onError={(e) => { 
                        e.target.src = 'https://via.placeholder.com/100?text=' + user.name[0] 
                    }}
                />
            </Box>
            
            {/* Name with "Chores" */}
            <Typography 
                variant="h5" 
                fontWeight="900"
                sx={{ 
                    color: 'white',
                    fontSize: { xs: '1.1rem', md: '1.35rem' },
                    textAlign: 'center',
                    textShadow: '0 2px 4px rgba(0,0,0,0.2)'
                }}
            >
                {user.name} Chores
            </Typography>
        </Paper>
    );
};

export default ChoreTile;
